// The one subscription a zone needs (PLAN-CLIENT-SPLIT day 8).
//
// `SessionView` is what each zone draws, as values, with an `OptionId` on
// every control; the click goes back as `session.choose(option)`. A zone that
// reads this and calls `choose` imports nothing from the engine — what a
// control *does* stays on the other side of the line.

import { useMemo, useSyncExternalStore } from "react";

import type { Session, SessionView } from "src/api";

import { useGame } from "./useGame";

/** The whole view, rebuilt when the session's revision moves. */
export function useSessionView(): SessionView {
  const { session } = useGame();
  const revision = useSyncExternalStore(
    session.subscribe,
    () => session.revision,
    () => session.revision
  );
  return useMemo(() => session.view(), [session, revision]);
}

/** The session's verbs, for a zone that only needs to hand an option back. */
export function useSession(): Session {
  return useGame().session;
}
